import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'filters';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/FiltersPage')), {
  delay: 500
});